import React, { useRef, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";

const DoughnutChartSmall = ({ dataset, additionalOptions }) => {
  const chartRef = useRef(null);

  const data = {
    datasets: [
      {
        data: dataset,
        backgroundColor: ["#008CFF", "rgba(42, 54, 69, 0.5)"],
        borderWidth: 0,
        circumference: 360,
        rotation: 90,
        borderRadius: 20,
      },
    ],
  };

  const defaultOptions = {
    cutout: "89%",
    responsive: true,
    maintainAspectRatio: true,
    animation: {
      duration: 1500,
      easing: "easeOutQuart",
    },
    plugins: {
      tooltip: { enabled: false },
      legend: { display: false },
    },
  };

  const options = { ...defaultOptions, ...additionalOptions };

  return <Doughnut ref={chartRef} data={data} options={options} />;
};

export default DoughnutChartSmall;
